const CreateEvaluationWithAI = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="sparkShadow">
        <feDropShadow dx="0.3" dy="0.3" stdDeviation="1.5" floodOpacity="0.6" />
      </filter>
    </defs>

    <g transform="translate(0, 2)">
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14 10.83H10.83V14H9.17V10.83H6V9.17H9.17V6H10.83V9.17H14V10.83Z"
        fill="currentColor"
        stroke="none"
      />
    </g>

    <g transform="translate(13.5, 0.5) scale(0.08)">
      <path
        d="M50 10
           C55 30, 70 45, 90 50
           C70 55, 55 70, 50 90
           C45 70, 30 55, 10 50
           C30 45, 45 30, 50 10Z"
        fill="currentColor"
        opacity="0.9"
        filter="url(#sparkShadow)"
      />
    </g>

    <g transform="translate(17.5, 4.5) scale(0.06)">
      <path
        d="M50 10
           C55 30, 70 45, 90 50
           C70 55, 55 70, 50 90
           C45 70, 30 55, 10 50
           C30 45, 45 30, 50 10Z"
        fill="currentColor"
        opacity="0.8"
        filter="url(#sparkShadow)"
      />
    </g>

    <g transform="translate(15, 8.5) scale(0.045)">
      <path
        d="M50 10
           C55 30, 70 45, 90 50
           C70 55, 55 70, 50 90
           C45 70, 30 55, 10 50
           C30 45, 45 30, 50 10Z"
        fill="currentColor"
        opacity="0.7"
        filter="url(#sparkShadow)"
      />
    </g>
  </svg>
);

export default CreateEvaluationWithAI;
